import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const sidebarApi = {
  /**
   * GET ALL WIDGETS (Performance Optimized - Single API Call)
   * Endpoint: GET /api/feed/sidebar
   * Params: {
   *   includeOnlineFriends,
   *   includeSuggestions,
   *   includeTrendingTopics,
   *   includeStats,
   *   includeCollaborationOpportunities
   * }
   * Response: {
   *   success: true,
   *   data: {
   *     onlineFriends: [...],
   *     suggestions: [...],
   *     trendingTopics: [...],
   *     userStats: {...},
   *     collaborationOpportunities: [...]
   *   }
   * }
   */
  getAllWidgets: async ({
    includeOnlineFriends = true,
    includeSuggestions = true,
    includeTrendingTopics = true,
    includeStats = true,
    includeCollaborationOpportunities = true,
    onlineFriendsLimit = 5,
    suggestionsLimit = 3,
    trendingLimit = 5,
    collaborationLimit = 3,
  } = {}) => {
    return apiClient.get("/feed/sidebar", {
      params: {
        includeOnlineFriends,
        includeSuggestions,
        includeTrendingTopics,
        includeStats,
        includeCollaborationOpportunities,
        onlineFriendsLimit,
        suggestionsLimit,
        trendingLimit,
        collaborationLimit,
      },
    });
  },

  /**
   * GET ONLINE FRIENDS (Individual - Use only for debugging)
   * Endpoint: GET /api/feed/online-friends
   * @deprecated Use getAllWidgets() for better performance
   */
  getOnlineFriends: async (limit = 5) => {
    return apiClient.get("/feed/online-friends", { params: { limit } });
  },

  /**
   * GET PEOPLE SUGGESTIONS (Individual - Use only for debugging)
   * Endpoint: GET /api/feed/people-suggestions
   * @deprecated Use getAllWidgets() for better performance
   */
  getPeopleSuggestions: async (limit = 3) => {
    return apiClient.get("/feed/people-suggestions", { params: { limit } });
  },

  /**
   * GET TRENDING TOPICS (Individual - Use only for debugging)
   * Endpoint: GET /api/feed/trending-topics
   * @deprecated Use getAllWidgets() for better performance
   */
  getTrendingTopics: async (limit = 5) => {
    return apiClient.get("/feed/trending-topics", { params: { limit } });
  },

  /**
   * GET USER STATS (Individual - Use only for debugging)
   * Endpoint: GET /api/feed/user-stats
   * @deprecated Use getAllWidgets() for better performance
   */
  getUserStats: async () => {
    return apiClient.get("/feed/user-stats");
  },
};

export default sidebarApi;
